import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { PlatformService } from 'src/app/platform.service';
import { DataService } from 'src/app/services/data.service';
import { DisclaimersService } from 'src/app/services/disclaimers.service';
import { GuestPaymentformPage } from '../guest-paymentform/guest-paymentform.page';
import { ReceiptPage } from '../receipt/receipt.page';
import { LanguageService } from 'src/app/services/language.service';
import { ErrorHandlerService } from 'src/app/services/error-handler.service';
@Component({
  selector: 'app-guest-checkout',
  templateUrl: './guest-checkout.page.html',
  styleUrls: ['./guest-checkout.page.scss'],
})
export class GuestCheckoutPage implements OnInit {
  paymentForm: FormGroup = new FormGroup({});
  @Input() violation
  payType = '';
  parseFloat = parseFloat;
  loaded = false;
  payment
  step1Complete = false;
  step2Complete = false;
  submitLoading = false;
  width = window.innerWidth;
  item={}
  checkedOutCart = {};
  constructor(
    private errorHandlerSRV:ErrorHandlerService,
    public dataService: DataService,
    private disclaimerSRV:DisclaimersService,
    public platformSRV:PlatformService,
    private fb: FormBuilder,
    public modalController: ModalController,
    public dataSRV:DataService
  ) { 
    this.paymentForm = this.fb.group({
      'email':'',
                'name': '',
                'phone_number':'',
                'address_1':'',
                'address_2':'',
                'city':'',
                'province':'',
                'postal':''
    });
    this.item['item'] = [];
  }

  ngOnInit() {
    var disclaimer;
    disclaimer= this.disclaimerSRV.disclaimers.find(disclaimer=>disclaimer['data_trigger']=='guest-checkout-loaded' && disclaimer['locale']==this.dataSRV.selected && disclaimer['content']!=null)
    
      if(disclaimer && disclaimer['active']){
        this.dataService.createAndOpenModal(disclaimer).then(data=>{
          if(data){
           this.proceed()
          }
           else {
            this.closeModal()
           }
         })
      } else {
        this.proceed()
      }
   
  }
  proceed(){
   
    this.dataSRV.postDataWithQuery(this.violation['violation']['ViolationID']).subscribe({
      next:(data:any)=>{
        if(data?.status=='success'){
          this.payment=data
      this.loaded=true
      this.violation=data['items']['violation'][0]
      if(data['summary'].total==0 || data?.paymentTypes.length==1){
        this.payType=data['paymentTypes'][0]
      }
        } else {
          this.loaded=true
          this.errorHandlerSRV.displayErrorMessage(data,true)
        }
      }, error:err=>{
        this.loaded=true
        this.errorHandlerSRV.displayErrorMessage(err,true)
      }
      
     })
  }
  closeModal() {
    this.modalController.dismiss()
  }
  async submitPayment() {
    if(this.payType['promptFor'].toLowerCase()=='anonymous'){
      this.paymentForm = this.fb.group({
        'email':''
      })
    } else if(this.payType['promptFor'].toLowerCase()=='billing') {
      this.paymentForm= this.fb.group({
        'email':'',
        'name': '' ,
        'phone_number':'',
        'address_1':'',
        'address_2':'',
        'city':'',
        'province':'',
        'postal':''
      })
    }
    this.submitLoading = true;
    this.item['item'] = [];
    this.item['item'].push('violation:' +this.violation['ViolationID']);
    var  data= {
      paymentForm:this.paymentForm,
      payType:this.payType,
      cartTotal:this.payment['summary'],
      item:this.item,
      fees:this.payment?.after_items?.fees

    }
    
    const desktopModal = await this.modalController.create({
      component: GuestPaymentformPage,
      breakpoints: [0.5, 0.8, 1],
initialBreakpoint: 1,
      cssClass: 'modal-desktop-long',
      componentProps: {
        ...data
      },
    });
    const mobileModal = await this.modalController.create({
      component: GuestPaymentformPage,
      breakpoints: [0.5, 0.8, 1],
initialBreakpoint: 1,
      cssClass: 'modal-mobile-normal',
      componentProps: {
        ...data
      },
    });
    const tabletModal = await this.modalController.create({
      component: GuestPaymentformPage,
      breakpoints: [0.5, 0.8, 1],
initialBreakpoint: 1,
      cssClass: 'modal-tablet-normal',
      componentProps: {
        ...data

      },
    });
    var modal = await this.dataService.getModalType(mobileModal, tabletModal, desktopModal)
    modal.onDidDismiss().then(res=>{
      if(res.data!="keep open"){
      this.modalController.dismiss().then(()=>{
        this.modalController.dismiss().then(()=>{
          this.openReceipt(res.data?.receiptID)
        })
      })
     }
      
    })
    modal.present()
    this.submitLoading = false;
    // this.dataSRV
    //   .postData('guest/confirm', this.item)
    //   .subscribe({
    //     next: (res) => {
    //       if (res['status'] == 'success') {
            
           
           
            
    //         this.submitLoading = false;
    //         this.step1Complete = true;
    //         // this.checkedOutCart = res;
    //       } else {
    //         this.submitLoading = false;
    //         this.step1Complete = false;
    //         // this.toastSRV.presentErrorToast(res['message']);
    //       }
    //     },
    //     error: (err) => {
    //       this.submitLoading = false;
    //       this.step1Complete = false;
    //       // this.toastSRV.presentErrorToast('An error Occured, try again');
    //     },
    //   });
  }
  async openReceipt(receiptID){
   
      const desktopModal = await this.modalController.create({
        component: ReceiptPage,
        breakpoints: [0.5, 0.8, 1],
        initialBreakpoint: 1,
        cssClass: 'modal-desktop-long',
        componentProps: {
         receiptID:receiptID,
         modalPage:true
        },
      });
      const mobileModal = await this.modalController.create({
        component: ReceiptPage,
        breakpoints: [0.5, 0.85, 1],
        initialBreakpoint: 1,
        cssClass: 'modal-mobile-normal',
        componentProps: {
          receiptID:receiptID,
          modalPage:true
        },
      });
      const tabletModal = await this.modalController.create({
        component: ReceiptPage,
        breakpoints: [0.5, 0.85, 1],
        initialBreakpoint: 1,
        cssClass:'modal-mobile-normal',
        componentProps: {
          receiptID:receiptID,
          modalPage:true
        },
      });
      if(this.platformSRV.device=='desktop'){
        return await desktopModal.present();
      } else if(this.platformSRV.device=='mobile'){
        return await mobileModal.present();
      } else if(this.platformSRV.device=='tablet'){
        return await tabletModal.present();
      }
    
    
  }


}
